<template>
  <section class="bg-black -mt-40 sm:-mt-40 overflow-hidden">
    <div
      class="w-full bg-black menu-page-container flex sm:flex-col sm:pt-0 pt-40"
      data-aos="fade"
    >
      <div class="sm:w-full w-5/12 sm:pt-4">
        <div class="sm:mt-0 sm:mr-0 mt-32 mr-20">
          <menu-image-scroll></menu-image-scroll>
        </div>
        <!-- <div class="text-white">
          <div
            class="IRASHAI text-2xl sm:p-6 sm:py-8 sm:text-xl"
            data-aos="fade-left"
          >
            I T A D A K I M A S U !
          </div>
        </div>-->
      </div>
      <div class="sm:w-full sm:mt-0 w-7/12 mt-40">
        <!--<div class="sm:flex-col flex justify-start" data-aos="fade-up">
          <h1
            class="text-4xl w-5/12 sm:w-full text-white mr-20 pl-5 sm:pl-6 float-left menu-title sm:mr-0 tracking-wider"
          >
            OUR <br class="sm:hidden" />MENU
          </h1>

          <p
            class="text-white ml-20 w-7/12 sm:w-full sm:p-6 sm:ml-0 float-right menu-introtext"
          >
            We believe it fuels our passion by appreciating cultural diversity
            and creating new dishes. Being able to satisfy everyone is our
            ultimate goal.
          </p>
        </div>-->
        <div class="mt-20 mb-20 sm:mt-4 sm:p-6">
          <sushi-menu></sushi-menu>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SushiMenu from "../components/SushiMenu";
import MenuImageScroll from "../components/MenuImageScroll";
export default {
  components: {
    MenuImageScroll,
    SushiMenu
  }
};
</script>

<style>
#red-text-menu {
  position: relative;
  width: 50%;
  height: auto;
  left: 17%;
  padding-top: 4rem;
}
.menu-title {
  font-family: Times;
  font-style: normal;
  font-weight: normal;
}
.menu-introtext {
  font-family: avenirLight;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  /* or 150% */

  letter-spacing: 0.05em;

  color: #ffffff;
}
.menu-page-container {
  max-width: 80%;

  margin: auto;
}
@media only screen and (max-width: 639px) {
  .menu-page-container {
    max-width: 100%;

    margin: auto;
  }
}
</style>